
import styled from 'styled-components';

import BackgroundMap from "../../assets/backgroundmap.svg"

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    width: 100vw;
    height: 100vh;

    background-image: url(${BackgroundMap});
    background-repeat: no-repeat;
    background-position: center;

    span {
        font-family: IBM Plex Sans;
        color: var(--grey-100);
    }
`
